import React from "react";

const LogoPreview = ({ imgSrc }) => {
  return (
    <div className="px-10">
      <img
        src={imgSrc ? imgSrc : null}
        style={{
          height: "100%",
          maxHeight: "42px",
        }}
      />
    </div>
  );
};

export default LogoPreview;
